export default __webpack_public_path__ + "static/media/unitary-llb.d8868f6b.webp";